import Playground from 'components/Playground';
import Badge from "components/Badge";
import * as React from 'react';
export default {
  Playground,
  Badge,
  React
};